import { authService } from '../api';
import { useApi } from './useApi';
import { showToast } from '../utils/toast';

export const usePasswordReset = () => {
  const { loading, error, execute } = useApi({
    successMessage: 'Password reset link has been sent to your email!',
    showSuccessToast: true,
    showErrorToast: true,
  });

  const requestPasswordReset = async (email: string) => {
    if (!email) {
      showToast.error('Please enter your email address');
      return;
    }
    return execute(() => authService.requestPasswordReset(email));
  };

  return {
    requestPasswordReset,
    loading,
    error,
  };
};
